const galleryConstant = [
  {
    src: require("../../assets/images/gallery/1.jpg"),
    topic: "ค่ายที่ไม่เหมือนใคร และไม่มีใครเหมือน !",
    description:
      "หากน้อง ๆ มีความฝันและอยากมาร่วมสัมผัสบรรยากาศของวิศวฯ จุฬาฯ โดยตรง ค่ายลานเกียร์ยินดีต้อนรับน้อง ๆ ทุกคนเข้าสู่บ้านของเรา อย่ารอช้า ! ประสบการณ์และความสนุกอันล้ำค่ากำลังรออยู่ :3"
  },
  {
    src: require("../../assets/images/gallery/2.jpg"),
    topic: "ค่ายที่ไม่เหมือนใคร และไม่มีใครเหมือน !",
    description:
      "หากน้อง ๆ มีความฝันและอยากมาร่วมสัมผัสบรรยากาศของวิศวฯ จุฬาฯ โดยตรง ค่ายลานเกียร์ยินดีต้อนรับน้อง ๆ ทุกคนเข้าสู่บ้านของเรา อย่ารอช้า ! ประสบการณ์และความสนุกอันล้ำค่ากำลังรออยู่ :3"
  },
  {
    src: require("../../assets/images/gallery/3.jpg"),
    topic: "สิบปากว่าไม่เท่าตาเห็น อยากรู้ต้องเข้ามาดู",
    description:
      "ค่ายลานเกียร์เปิดโอกาสให้น้อง ๆ ทุกคนได้สัมผัสกับวิศวฯ จุฬาฯ อย่างใกล้ชิด ได้เรียนรู้และเข้าใจการเรียนภายในคณะวิศวกรรมศาสตร์ จากนิสิตและคณาจารย์ผู้ทางคุณวุฒิ ถ้าพร้อมแล้วก็เข้ามาดูมาสัมผัสได้เลยที่ค่ายลานเกียร์เท่านั้น !"
  },
  {
    src: require("../../assets/images/gallery/4.jpg"),
    topic: "สิบปากว่าไม่เท่าตาเห็น อยากรู้ต้องเข้ามาดู",
    description:
      "ค่ายลานเกียร์เปิดโอกาสให้น้อง ๆ ทุกคนได้สัมผัสกับวิศวฯ จุฬาฯ อย่างใกล้ชิด ได้เรียนรู้และเข้าใจการเรียนภายในคณะวิศวกรรมศาสตร์ จากนิสิตและคณาจารย์ผู้ทางคุณวุฒิ ถ้าพร้อมแล้วก็เข้ามาดูมาสัมผัสได้เลยที่ค่ายลานเกียร์เท่านั้น !"
  },
  {
    src: require("../../assets/images/gallery/5.1.jpg"),
    topic: "หนึ่งค่าย ล้านความทรงจำ",
    description:
      "นอกจากความรู้ทางวิชาการแล้ว ค่ายลานเกียร์ยังมอบความทรงจำดี ๆ ให้แก่ทุกคน สายสัมพันธ์และความสุขของน้อง ๆ ผู้มาเข้าค่ายและพี่ ๆ ผู้จัดค่ายไม่ว่าจะเวลาจะผ่านไปนานขนาดไหนก็จะตราตรึงในใจของน้อง ๆ ไม่มีวันจางหายแน่นอน !"
  },
  {
    src: require("../../assets/images/gallery/5.2.jpg"),
    topic: "หนึ่งค่าย ล้านความทรงจำ",
    description:
      "นอกจากความรู้ทางวิชาการแล้ว ค่ายลานเกียร์ยังมอบความทรงจำดี ๆ ให้แก่ทุกคน สายสัมพันธ์และความสุขของน้อง ๆ ผู้มาเข้าค่ายและพี่ ๆ ผู้จัดค่ายไม่ว่าจะเวลาจะผ่านไปนานขนาดไหนก็จะตราตรึงในใจของน้อง ๆ ไม่มีวันจางหายแน่นอน !"
  }
]

export default galleryConstant
